import icons from '../../../../constants/icons';

export type IconKey = keyof typeof icons;

export const IMPORT_STEP_DEFINITIONS: readonly {
  id: string;
  labelKey: string;
  icon: IconKey;
}[] = [
  {
    id: 'connect',
    labelKey: 'Connecting to Steam API',
    icon: 'CLOUD_ARROW_DOWN',
  },
  {
    id: 'fetch',
    labelKey: 'Fetching game catalog',
    icon: 'GAME',
  },
  {
    id: 'parse',
    labelKey: 'Parsing game metadata',
    icon: 'TERMINAL',
  },
  {
    id: 'sku',
    labelKey: 'Extracting SKU data',
    icon: 'CUBES_STACKED',
  },
  {
    id: 'sync',
    labelKey: 'Syncing to database',
    icon: 'DATABASE',
  },
];

export type StepRunState = {
  id: string;
  status: 'pending' | 'active' | 'complete';
};

export interface ImportedGame {
  id: string;
  name: string;
  appId: string;
  skuCount: number;
  status: 'importing' | 'complete';
}

export interface SelectablePackage {
  packageId: string;
  name: string;
  existsInAlaska: boolean;
  selected: boolean;
}

export interface SelectableGame {
  name: string;
  appId: string;
  existsInAlaska: boolean;
  existingGameId?: string;
  selected: boolean;
  packages: SelectablePackage[];
}

export interface LogEntry {
  id: string;
  timestamp: string;
  message: string;
  type: 'info' | 'success' | 'warning';
}

/** Games returned from API, normalized for the import list. */
export type FetchedGame = { name: string; appId: string; skuCount: number };

export interface KeyProviderOption {
  id: string;
  name: string;
  steamIntegrationEnabled?: boolean;
}

export type SteamImportFormValues = {
  appIds: string;
  platformId: string;
  keyProviderId: string;
  packageTypeId: string;
  publisherCompanyId: string;
};

export function getStepIcon(id: string): IconKey {
  return IMPORT_STEP_DEFINITIONS.find((s) => s.id === id)?.icon ?? 'TERMINAL';
}

export const STEP_LABEL_KEYS: Record<string, string> = Object.fromEntries(
  IMPORT_STEP_DEFINITIONS.map((s) => [s.id, s.labelKey])
);
